import * as React from 'react';
import { alpha, styled } from '@mui/material/styles';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import MobileStepper from '@mui/material/MobileStepper';
import {QRCodeSVG} from 'qrcode.react';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import Sparkle from 'react-sparkle'

const API = require("../../data/network/API");


const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#1a90ff',
    ...theme.applyStyles('dark', {
      backgroundColor: '#308fe8',
    }),
  },
}))

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function Stepper(props) {
  const {questionary, setComplete, setResult} = props
  const [activeStep, setActiveStep] = React.useState(0)
  const [progress, setProgress] = React.useState(questionary.preguntas[0].segundos)
  const [selectedIndex, setSelectedIndex] = React.useState(null)
  const [questionaryAnswered, setQuestionaryAnswered] = React.useState(questionary)
  const [lock, setLock] = React.useState(false)
  const [correctIndex, setCorrectIndex] = React.useState()
  const [correcto, setCorrecto] = React.useState()

  const handleListItemClick = (event, index) => {
    if(lock===false){
      setSelectedIndex(index);
      var quest = questionary

      if(questionary.preguntas[activeStep].opciones[index].es_correcta){
        quest.preguntas[activeStep].correcto = true
        setLock(true)
      }else{
        quest.preguntas[activeStep].correcto = false
        setLock(true)
      }

      questionary.preguntas[activeStep].opciones.forEach(opcion =>{
        if(opcion.es_correcta){
          setCorrectIndex(opcion.id)
        }
      })

      setQuestionaryAnswered(quest)

    }
  }

  const handleSubmitFreeAnswer = async(event) => {
    event.preventDefault();
    if(lock === false){
      const data = new FormData(event.currentTarget);
      const respuesta = data.get('respuesta')
      var quest = questionary
      quest.preguntas[activeStep].respuesta_usuario = respuesta
      setLock(true)
      if(respuesta == questionary.preguntas[activeStep].respuesta){
        setCorrecto(true)
        quest.preguntas[activeStep].correcto = true
      }else{
        setCorrecto(false)
        quest.preguntas[activeStep].correcto = false
      }
      setQuestionaryAnswered(quest)
    }
  }

  async function postQuiz(){
    const signin_data = localStorage.getItem("signin-data");
    const data = JSON.parse(signin_data);
    const requestBody= questionaryAnswered
    requestBody.id_usuario = data.usuario.firestore_id 

    console.log(requestBody)
    const response = await API.postQuiz(requestBody)
    console.log(response)
    if(response.status == 200){
      setResult(response.data)
      setComplete(true)
    }else{

    }
  }

  function handleNext() {
    if(activeStep == questionary.preguntas.length-1){
     
      postQuiz()
      return
    }
    setSelectedIndex(null)
    setCorrecto(null)
    setLock(false)
    setCorrectIndex(null)
    setActiveStep(activeStep + 1);
  }

  function letterByIndex(index){
    const abc= ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "ñ", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"]
    return abc[index]+")"
  }

  React.useEffect(() => {
    if (!progress){ handleNext()}
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
         prevProgress - 1
      );
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, [progress])

  React.useEffect(() => {
    setProgress(questionary.preguntas[activeStep].segundos)
  },[activeStep])

  return (
    <Box sx={{ alignContent: "center" }}>
      <Stack spacing={5} sx={{mb:2}}>
        <Typography variant="h4" sx={{fontWeight:"bolder", textAlign:'center'}} > {questionary.preguntas[activeStep].pregunta}</Typography>
        <Box >
         <BorderLinearProgress variant="determinate" value={Math.round((100 / questionary.preguntas[activeStep].segundos) * progress)} />
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              variant="body2"
              sx={{ cursor: 'pointer' }}
            >
              0 seg
            </Typography>
            <Typography
              variant="body2"
              sx={{ cursor: 'pointer' }}
            >
              {progress} seg
            </Typography>
          </Box>
        </Box>
      </Stack>
      <>
      {questionary.preguntas[activeStep].opciones && questionary.preguntas[activeStep].opciones.length > 0?
        <>
          <List component="nav"  >
            {questionary.preguntas[activeStep].opciones?.map((opcion) => (
              <ListItemButton
                key={opcion.id}
                sx={{ 
                  mb: 2, 
                  borderRadius: 16,
                  color: selectedIndex == opcion.id ? "white !important": (correctIndex == opcion.id ? "white !important":  "black !important"),
                  backgroundColor: correctIndex == opcion.id ? "#45da72 !important": "#fff !important",
                  "&.Mui-selected": {
                    backgroundColor: correctIndex == opcion.id ? "#008000 !important": "#FF0000 !important",
                    color: "white",
                    
                    "@keyframes slideInFromRight": {
                      "0%" :{ transform: "rotate(0deg)" },
                      "25%" :{ transform: "rotate(5deg)" },
                      "50%" :{ transform: "rotate(0eg)" },
                      "75%" :{ transform: "rotate(-5deg)" },
                      "100%": { transform: "rotate(0deg)" },
                    },
                   animation: "slideInFromRight 0.6s ease-out forwards",
                  
                  },
                  "&:hover": {
                      backgroundColor: "#FFF"
                  }

                  
                }} 
                selected={selectedIndex == opcion.id}
                onClick={(event) => handleListItemClick(event, opcion.id)}
              >
                <ListItemText key={opcion.id} primary={<Typography variant="body" sx={{fontWeight:'bolder'}}>{letterByIndex(opcion.id)} {opcion.opcion}</Typography>} />
              </ListItemButton>
            ))}
          </List>
        </>
          :
          <Box component="form" noValidate onSubmit={handleSubmitFreeAnswer} sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="respuesta"
              name="respuesta"
              autoComplete="text"
              variant="outlined"
              autoFocus
              color='secondary'
              error={correcto==false}
              label = "Ingresa tu respuesta"
              helperText = {correcto == null ? "Ingresa tu respuesta": correcto == false  ? "Incorrecto": "Correcto"}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color='secondary'
              sx={{ mt: 3, mb: 2 }}
            >
              enviar
            </Button>
          </Box> 
      }
      </>
      <Stack sx={{ justifyContent: "center", alignItems: "center"}}>
        <MobileStepper
          variant="dots"
          sx={{ bgcolor: 'transparent', '& .MuiMobileStepper-dot': {
            backgroundColor: 'darkgray',
          },
          '& .MuiMobileStepper-dotActive': {
            backgroundColor: "white",
          },}}
        
          steps={questionary.preguntas.length}
          position="static"
          activeStep={activeStep}
        />
      </Stack>
    </Box>
  )
}

export default function QuizQuestions() {
  const {state} = useLocation();
  const [questionary, setQuestionary] = React.useState(state);
  const [open, setOpen] = React.useState(false);
  const [complete, setComplete] = React.useState(false);
  const [result, setResult] = React.useState(false);

  const handleClickOpen = () => {
      setOpen(true);
  }
  
  const handleClose = () => {
      setOpen(false);
  }
  
  return (
      <Box sx={{ 
            flexGrow: 1, 
            px: 2, 
            backgroundImage: `radial-gradient(circle at top left, rgba(60, 60, 60, 0.39) 0%, rgba(10, 10, 10, 0.86) 100%), url(${questionary.imagen_url}) !important`,
            backgroundRepeat: `no-repeat`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: "100vh",
            width: "100%",
        }}>    
          <div sx={{ my: 1, mx: 'auto'}}>
            <Stack spacing={3} sx={{ py:16, alignItems:'center'}}> 
                {!result ?
                  <Stepper questionary = {questionary} setComplete={setComplete} setResult={setResult}></Stepper>
                  :
                  <>
                  <QRCodeSVG value={result.firestore_id} />   
                    <Typography variant="h4" fontWeight="bolder" gutterBottom sx = {{textAlign:'center'}}>
                      ¡Gracias por participar!
                    </Typography>
                    <Sparkle
                      color="orange"
                      count={20}
                      minSize={20}
                      maxSize={30}
                      overflowPx={0}
                      fadeOutSpeed={10}
                      flicker={false}
                    />
                    <Button disabled={!complete} size="large"  variant='contained' color='secondary' onClick={handleClickOpen}>
                      Continuar
                    </Button>
                  </>
                }
            </Stack>
          </div>
          <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle>{"¡Gracias por participar!"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                Canjea tu codigo por un premio
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color='secondary'>Cancelar</Button>
              <Button onClick={handleClose} color='secondary'>Aceptar</Button>
            </DialogActions>
          </Dialog>
      </Box>
  )
}